import { IPermissionSetGrouping, PermissionSetGroupingKey } from '../../PermissionSetTypes'
import { PermissionType } from '../../PermissionType'
import { DefaultSuperAdminPermissionSet, defaultSuperAdminPermissionSetGrouping } from './DefaultSuperAdminPermissions'
import { SuperAdminOrganizationPermissions } from './SuperAdminPermissions'

export enum PartnerSuccessPermissionSet {
  PartnerSuccess = 'super_admin_partner_success',
}

export const partnerSuccessPermissionSetGrouping: IPermissionSetGrouping<PartnerSuccessPermissionSet> = {
  key: PermissionSetGroupingKey.SuperAdminPartnerSuccess,
  active: {
    [PartnerSuccessPermissionSet.PartnerSuccess]: [
      ...defaultSuperAdminPermissionSetGrouping.active[DefaultSuperAdminPermissionSet.DefaultSuperAdmin],
      ...SuperAdminOrganizationPermissions.manageAny,
      PermissionType.DELETE_ORGANIZATION_RIDERS,
      PermissionType.DELETE_ANY_ORGANIZATION_EAM_DATA,
    ],
  },
  unAssignablePermissionSets: [PartnerSuccessPermissionSet.PartnerSuccess],
  isSuperAdminSet: true,
}
